import * as React from "react";
import {observer} from "mobx-react";
import {TableView} from "../../../abstract/TableView";
import {XyiconFeature} from "../../../../../generated/api/base";
import type {PortfolioGroup} from "../../../../../data/models/PortfolioGroup";
import {CreatePortfolioGroupPanel} from "./CreatePortfolioGroupPanel";
import {PortfolioGroupDetailsContent} from "./PortfolioGroupDetailsContent";

@observer
export class PortfolioGroupsView extends React.Component {
	private _headers = [
		{
			id: "name",
			title: "Group Name",
		},
		{
			id: "portfolioIds",
			title: "Number of portfolios",
		},
		{
			id: "lastModifiedAt",
			title: "Last Updated",
		},
		{
			id: "lastModifiedBy",
			title: "Updated By",
		},
	];

	public override render() {
		return (
			<TableView
				feature={XyiconFeature.PortfolioGroup}
				headers={this._headers}
				create={(onCreated, onCancel, creating) => (
					<CreatePortfolioGroupPanel
						onCancel={onCancel}
						onCreated={onCreated}
						creating={creating}
					/>
				)}
				details={(selected: PortfolioGroup[]) => <PortfolioGroupDetailsContent portfolioGroups={selected} />}
			/>
		);
	}
}
